module.exports = __webpack_public_path__ + "static/media/joe-bg.609abff1.mp4";